import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { Router, RouterLink } from "@angular/router";
import { MatMenuModule } from "@angular/material/menu";
import { AuthService } from "./service/auth.service";
import { MAIN_MENU } from "./shared/main-menu.data";
import { MainMenuComponent } from "./shared/main-menu.component";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    RouterLink,
    MainMenuComponent,
  ],
  templateUrl: "./app-header.component.html",
  styleUrls: ["./app-header.component.scss"],
})
export class AppHeaderComponent {
  mainMenu = MAIN_MENU;

  @Input() userAvatarUrl = "/assets/avatar.svg"; // remplace si tu as l’URL

  constructor(private router: Router, protected authService: AuthService) {}

  refresh(): void {
    // Option 1: recharger la route Angular proprement
    const url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(url);
    });

    // Option 2 (simple): rechargement dur
    // window.location.reload();
  }

  logout(): void {
    // TODO: branche ton AuthService ici
    // this.auth.logout();
    this.router.navigate(["/login"]);
  }
}
